import { useEffect, useMemo, useState } from 'react'
import { DEFAULT_ACCOUNT_CAPABILITIES } from 'constants/General'
import { useBulkCapabiltiesQuery } from 'hooks/queries/Capabilities/useCapabiltiesQuery'
import { AccountCapabilities } from 'types/capabilities/capabilities'
import { getAccountCapabilities, getAccountCapabilityRequestFilters } from 'utils/capabilities'

export const useAccountCapabilities = (accountReference: string) => {
  const [accountCapabilities, setAccountCapabilities] = useState<AccountCapabilities>(
    DEFAULT_ACCOUNT_CAPABILITIES
  )

  const accountCapabilityRequest = useMemo(() => {
    if (accountReference) {
      return getAccountCapabilityRequestFilters(accountReference)
    }
  }, [accountReference])

  const { data: accountCapabilitiesData, isFetching: isFetchingAccountCapabilities } =
    useBulkCapabiltiesQuery(accountCapabilityRequest, !!accountCapabilityRequest)

  const accountCapabilitiesDetails = useMemo(() => {
    if (!!accountCapabilitiesData && !!accountReference) {
      return getAccountCapabilities(accountReference, accountCapabilitiesData)
    }
  }, [accountReference, accountCapabilitiesData])

  useEffect(() => {
    if (!!accountCapabilitiesDetails && !isFetchingAccountCapabilities) {
      setAccountCapabilities(accountCapabilitiesDetails)
    }
  }, [accountCapabilitiesDetails, isFetchingAccountCapabilities])

  return {
    accountCapabilities,
    isFetchingAccountCapabilities,
  }
}
